import { useState, useEffect } from 'react';
import { Select, Switch as AntSwitch } from 'antd';
import Card from '../../common/components/Card';
import { Switch, Route, useHistory, useParams } from 'react-router-dom';
import ManualTimesheetCard from './ManualTimesheetCard';

export const ListUsers = props => {
  let history = useHistory();
  let { userId, endDate } = useParams();
  const [selectedUserId, setSelectedUser] = useState(userId);
  const [includeInactive, setIncludeInactive] = useState(false);
  const { users } = props;
  const { Option } = Select;

  const onChange = value => {
    setSelectedUser(value);
    history.push(
      endDate
        ? `/finance/manualTimesheets/${value}/${endDate}`
        : `/finance/manualTimesheets/${value}`,
    ); // Navigate using React Router
  };

  useEffect(() => {
    if (userId) {
      setSelectedUser(userId);
    }
  }, [userId]);

  // Filter users based on includeInactive toggle
  const filteredUsers = users ? users.filter(user => includeInactive || user.accountActive) : [];

  return (
    <>
      <Card floating padded={true} title="Add Timesheet for Other Users">
        <div className="flex flex-col md:flex-row justify-start items-start md:items-center gap-4">
          <Select
            showSearch
            style={{ width: 400 }}
            placeholder="Select a User"
            optionFilterProp="children"
            value={selectedUserId}
            onChange={onChange}
            filterOption={(input, option) =>
              option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            {filteredUsers &&
              filteredUsers.map(item => {
                let firstName = item.firstName ? item.firstName : '';
                let lastName = item.lastName ? item.lastName : '';
                let email = item.emails.length ? item.emails[0].address : '';
                return (
                  <Option value={item._id} key={item._id}>
                    {firstName + ' ' + lastName + ' - ' + email}
                  </Option>
                );
              })}
          </Select>

          <div className="flex flex-row justify-start items-center gap-2">
            <AntSwitch
              title="Include Inactive Users"
              checked={includeInactive}
              onChange={setIncludeInactive}
            />
            Include Inactive Users
          </div>
        </div>
      </Card>
      <Switch>
        <Route
          path="/finance/manualTimesheets/:userId/:endDate"
          render={() => <ManualTimesheetCard />}
        />
        <Route path="/finance/manualTimesheets/:userId" render={() => <ManualTimesheetCard />} />
      </Switch>
    </>
  );
};

export default ListUsers;
